import axios from "axios";
import React from 'react';
import {basicAuthHeader, bearerTokenHeader} from "./auth-service";

export async function getCoberturasByPlan(planNumber) {
    const response = await axios.get('http://34.216.212.246/plans/' + planNumber + '/coverages', {
        auth: basicAuthHeader() //145
    });
    return response.data;
}

export async function getCoberturasByInsuranceCompany(movementId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/quotes/' + movementId + '/coverages', {
        headers: bearerTokenHeader()
    });
    return response.data;
}

export async function getCoberturasByPackage(customerId, quotationId, packageId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/customers/settings/'+ customerId + '/quotation/' + quotationId + '/insurancehub/plans/type/' + packageId, {
        auth: basicAuthHeader(),
        headers: {PlatformId: 2}
    });
    return response.data;
}
